import { configureStore } from '@reduxjs/toolkit';
import agentsReducer from './slices/agentsSlice';
import schedulesReducer from './slices/schedulesSlice';
import statisticsReducer from './slices/statisticsSlice';
import timeAdjustmentsReducer from './slices/timeAdjustmentsSlice';

export const store = configureStore({
  reducer: {
    agents: agentsReducer,
    schedules: schedulesReducer,
    statistics: statisticsReducer,
    timeAdjustments: timeAdjustmentsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['agents/syncFromHelpScout/fulfilled'],
      },
    }),
});

export default store;
